/*
 * Slice to manage UI related Things
 */

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  showLogIn: false,
  showSignUp: false,
};

export const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    setShowLogIn: (state, action) => {
      state.showSignUp = false;
      state.showLogIn = action.payload;
    },
    setShowSignUp: (state, action) => {
      state.showLogIn = false;
      state.showSignUp = action.payload;
    },
  },
});

export const { setShowLogIn, setShowSignUp } = uiSlice.actions;

export default uiSlice.reducer;
